import {useLocation, useParams} from "react-router-dom";
import React, {useState} from "react";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    RaikoGridOneColumn,
    raikoBreadCrumbItemGenerator,
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../../route/RouteHelper";
import {css} from "@emotion/css";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import EtecafBasicInfo from "./EtecafBasicInfo";
import EtekafPlaceList from "./EtekafPlaceList";
import EtekafRequestList from "./EtekafRequestList";


export default function EtekafDetail() {

    const {id:etecafId=-1} = useParams()
    const {state} = useLocation();


    const [selectedValueTabMenu, setSelectedValueTabMenu] = useState(EtecafTabType.BasicInformation.id)

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.EtekafManagerList.name);

    function handleChangeTabMenu(event, newValue) {
        setSelectedValueTabMenu(newValue)
    }

    return (
        <>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.EtekafManagerList.name,
                                RouteHelper.EtekafManagerList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            )
                        ]}
                    />
                    <TabContext value={selectedValueTabMenu}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                        style={alignItems}>
                            <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                                <Tab
                                    icon={<div className="ic-areas" />}
                                    iconPosition="start"
                                    label={EtecafTabType.BasicInformation.title}
                                    value={EtecafTabType.BasicInformation.id}
                                />
                                <Tab
                                    icon={<div className="ic-areas" />}
                                    iconPosition="start"
                                    label={EtecafTabType.PlacesList.title}
                                    value={EtecafTabType.PlacesList.id}
                                />
                                <Tab
                                    icon={<div className="ic-areas" />}
                                    iconPosition="start"
                                    label={EtecafTabType.RequestList.title}
                                    value={EtecafTabType.RequestList.id}
                                />
                            </TabList>
                        </Box>
                        <TabPanel value={EtecafTabType.BasicInformation.id}>
                            <EtecafBasicInfo etecafId={etecafId}/>
                        </TabPanel>
                        <TabPanel value={EtecafTabType.PlacesList.id}>
                            <EtekafPlaceList etecafId={etecafId} />
                        </TabPanel>
                        <TabPanel value={EtecafTabType.RequestList.id}>
                            <EtekafRequestList etecafId={etecafId}/>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>
    )
}

const EtecafTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
    PlacesList: {
        id: "Places-list",
        title: "مکان های اعتکاف",
    },
    RequestList: {
        id: "request-list",
        title: "لیست درخواست ها",
    },

}
const alignItems = {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
    gap: "1rem",
};